<template>
    <div>
        <table class="table table-bordered table-striped table-responsive-lg">
            <thead class="thead-dark">
                <tr>
                    <th v-for="column in columns">{{column}}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><input type="text"></td>
                    <td><input type="text"></td>
                    <td><input type="date"></td>
                    <td><input type="date"></td>
                    <td><input type="text"></td>
                    <td><proveedor class="proveedor" v-model="modelProveedor"/></td>
                    <td><input type="text"></td>
                    <td><input type="text"></td>
                    <td><input type="text"></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import Proveedor from "../../../compra/component/selectCompras/Proveedor";
    export default {
        name: "tablaListar",
        components: {Proveedor},
        data(){
            return{
                modelProveedor:'',
                columns:['Folio','Folio Interno','Fecha','Fecha Ingreso','Neto'
                    ,'Proveedor','Estado','Sucursal id','Acciones']
            }
        }
    }
</script>

<style scoped>
    input{
        width: 100%;
    }
    .proveedor{
        width: 50%;
    }
</style>
